<template>
  <div>
    <div class="card head-card" v-if="userVisible">
      <div class="title-card">
        <h4>Mis pagínas</h4>
      </div>
      <div class="card-content">
        <p class="card-label">Lista de {{ network }}</p>
        <div class="checkbox todoBar">
          <label class="active todoList">
            <div class="user-avatar selectAll">
              <div class="data-avatar">Todo</div>
            </div>
            <input class="box" type="checkbox" :checked="allCheck2" @click="selectAllfav()" />

            <span class="nbox">
              <svg viewBox="0 0 14.018 13.003">
                <path id="Rectángulo_9" data-name="Rectángulo 9"
                  d="M304.98,386.9s1.489,1.413,3.5,3.546c4.553-2.794,10.514-9.457,10.514-9.457l-10.514,13Z"
                  transform="translate(-304.98 -380.994)" fill="#fff" />
              </svg>
            </span>
          </label>
        </div>
        <div class="row">
          <div class="checkbox col-md-6 col-sm-12 col-lg-4" v-for="(item, index) in dataUser" v-bind:key="item.key">
            <label :for="item.key">
              <div class="user-avatar">
                <div class="img-avatar">
                  <img :src="item.imagen" @error="replaceByDefault" class="avatarMin" /><!--NAYE-->
                </div>
                <div class="data-avatar">
                  <p class="user-name netTitle">
                    {{ item.nombre.length > 25 ? item.nombre.slice(0, 25) + '...' : item.nombre }}
                  </p>
                  <!-- <p class="user">
                  <a :href="item.link_feed" target="_BLANK">{{ item.link_feed }}</a>
                </p>-->
                </div>
              </div>
              <input class="box" type="checkbox" :id="item.key" :value="item.key"
                @click="selectMediaFavs(item.key, $event)" :checked="findID(item.key) || allCheck2" />

              <span class="nbox">
                <svg viewBox="0 0 14.018 13.003">
                  <path id="Rectángulo_9" data-name="Rectángulo 9"
                    d="M304.98,386.9s1.489,1.413,3.5,3.546c4.553-2.794,10.514-9.457,10.514-9.457l-10.514,13Z"
                    transform="translate(-304.98 -380.994)" fill="#fff" />
                </svg>
              </span>
            </label>
          </div>
        </div>
      </div>
    </div>

    <div class="card head-card">
      <div class="title-card">
        <h4>Lista de pagínas</h4>
      </div>
      <div class="card-content">
        <span style="display: flex; align-items: center;">
          <input class="input-text" type="text" placeholder="Buscar Canal" style="height: 24px; min-height: 20px; max-height: 28px; width: 200px; font-size: 13px; margin: 0 8px; padding: 2px 6px; border-radius: 4px; border: 2px solid #00B99E;" v-model="inSearch" />
          <button @click="feedsSearch" style="background: none; border: none; padding: 0; cursor: pointer; display: flex; align-items: center;">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#00B99E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>
          </button>
        </span>
        <!--<p class="card-label">Lista de {{ network }}</p>-->

        <div class="checkbox todoBar">
          <label class="active todoList">
            <div class="user-avatar selectAll">
              <div class="data-avatar">Todo</div>
            </div>
            <input class="box" type="checkbox" :checked="allCheck" @click="selectAll()" />

            <span class="nbox">
              <svg viewBox="0 0 14.018 13.003">
                <path id="Rectángulo_9" data-name="Rectángulo 9"
                  d="M304.98,386.9s1.489,1.413,3.5,3.546c4.553-2.794,10.514-9.457,10.514-9.457l-10.514,13Z"
                  transform="translate(-304.98 -380.994)" fill="#fff" />
              </svg>
            </span>
          </label>
        </div>

        <!--------->
        <div class="row">
          <div class="checkbox col-md-6 col-sm-12 col-lg-4" v-for="(item, index) in data" v-bind:key="item.key">
            <label :for="item.key">
              <div class="user-avatar">
                <div class="img-avatar">
                  <img :src="item.imagen" @error="replaceByDefault" class="avatarMin" /><!--NAYE-->
                </div>
                <div class="data-avatar">
                  <p class="user-name netTitle">
                    {{ item.nombre.length > 25 ? item.nombre.slice(0, 25) + '...' : item.nombre }}
                  </p>
                  <!-- <p class="user">
                    <a :href="item.link_feed" target="_BLANK">{{ item.link_feed }}</a>
                  </p>-->
                </div>
              </div>
              <input class="box" type="checkbox" :id="item.key" :value="item.key" :checked="findID(item.key) || allCheck"
                @click="selectMedia(item.key, $event)" />

              <span class="nbox">
                <svg viewBox="0 0 14.018 13.003">
                  <path id="Rectángulo_9" data-name="Rectángulo 9"
                    d="M304.98,386.9s1.489,1.413,3.5,3.546c4.553-2.794,10.514-9.457,10.514-9.457l-10.514,13Z"
                    transform="translate(-304.98 -380.994)" fill="#fff" />
                </svg>
              </span>
            </label>
          </div>
        </div>

        <div class="button-circle-more primary" v-if="more" @click="getMore(mediaShort)">
          <button class="circle-more">
            <svg viewBox="0 0 18 18">
              <g id="Grupo_29" data-name="Grupo 29" transform="translate(-171 -753)">
                <rect id="Rectángulo_redondeado_903" data-name="Rectángulo redondeado 903" width="2" height="18" rx="1"
                  transform="translate(179 753)" />
                <rect id="Rectángulo_redondeado_903_copia" data-name="Rectángulo redondeado 903 copia" width="18"
                  height="2" rx="1" transform="translate(171 761)" />
              </g>
            </svg>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// @ is an alias to /src
import axios from "axios";
import _ from "lodash";

export default {
  name: "smedia",
  components: {},
  data: () => ({
    data: [],
    dataUser: [],
    media: [],
    media2: [],
    mediaJoin: [],
    mediaShort: "",
    fiParams: [1, 1],
    allCheck: false,
    allCheck2: false,
    more: false,
    more2: false,
    lek: null,
    lek2: null,
    tMedia: "",
    dataSearch: [],
    inSearch: "",
  }),
  props: ["network"],
  computed: {
    url(){
      return this.$store.getters.getMainUrl;
    },
    token() {
      return this.$store.getters.getToken;
    },
    userVisible() {
      if (this.dataUser.length > 0) {
        return true;
      } else {
        return false;
      }
    },
    allCheckFn() {
      if (this.media.length > 0) {
        return false;
      } else {
        return true;
      }
    }
  },

  methods: {
    replaceByDefault(e) {
      var imagen = "";
      switch (this.network) {
        case "twitter":
          imagen = this.$store.state.defaultTwitter;
          break;
        case "youtube":
          imagen = this.$store.state.defaultYoutube;
          break;
        case "facebook":
          imagen = this.$store.state.defaultFacebook;
          break;
        case "instagram":
          imagen = this.$store.state.defaultInstagram;
          break;
        case "tiktok":
          imagen = this.$store.state.defaultTiktok;
          break;
      }
      e.target.src = imagen;
    },
    // ------------- NAY --------------------
    findAll() { },
    selectAll() {
      if (this.allCheck == false) {
        this.allCheck = true;
        this.media = [];
        this.mediaJoin = _.union(this.media, this.media2);
        let data = {
          mt: this.mediaShort,
          arr: this.mediaJoin
        };
        this.$store.commit("addMedia", data);
        this.fiParams[1] = 1;
        this.addfiParams();
      } else {
        this.allCheck = false;
        this.media = [];
        this.mediaJoin = _.union(this.media, this.media2);
        let data = {
          mt: this.mediaShort,
          arr: this.mediaJoin
        };
        this.$store.commit("addMedia", data);
        this.fiParams[1] = 0;
        this.addfiParams();
      }
    },
    selectAllfav() {
      if (this.allCheck2 == false) {
        this.allCheck2 = true;

        this.media2 = [];
        //join arrays
        this.mediaJoin = _.union(this.media, this.media2);
        let data = {
          mt: this.mediaShort,
          arr: this.mediaJoin
        };

        this.$store.commit("addMedia", data);
        this.fiParams[0] = 1;
        this.addfiParams();
      } else {
        this.allCheck2 = false;
        this.mediaArr2 = [];
        //join arrays
        this.mediaJoin = _.union(this.media, this.media2);
        let data = {
          mt: this.mediaShort,
          arr: this.mediaJoin
        };

        this.$store.commit("addMedia", data);
        this.fiParams[0] = 0;
        this.addfiParams();
      }
    },
    addToStore() {
      this.mediaJoin = _.union(this.media, this.media2);
      let data = {
        mt: this.mediaShort,
        arr: this.mediaJoin
      };
      this.$store.commit("addMedia", data);
    },
    addfiParams() {
      let data = {
        mt: this.mediaShort,
        arr: this.fiParams
      };
      this.$store.commit("addfiParams", data);
    },

    removeItem(media) {
      var index = this.media.indexOf(media);
      if (index > -1) {
        this.media.splice(index, 1);
      }
      this.addToStore();
    },
    removeItem2(media) {
      var index = this.media2.indexOf(media);
      if (index > -1) {
        this.media2.splice(index, 1);
      }
      this.addToStore();
    },
    selectMedia(media, element) {
      if (this.allCheck == true) {
        this.allCheck = false;
        this.media = [];
        element.target.checked = true;
      }

      if (element.target.checked == true) {
        this.media.push(media);
        this.fiParams[1] = 0;
        this.addfiParams();
        this.addToStore();
      } else {
        this.removeItem(media);
      }
    },
    selectMediaFavs(media, element) {
      if (this.allCheck2 == true) {
        this.allCheck2 = false;
        this.media2 = [];
        element.target.checked = true;
      }

      if (element.target.checked == true) {
        this.media2.push(media);
        this.addToStore();

        this.fiParams[0] = 0;
        this.addfiParams();
      } else {
        this.removeItem2(media);
      }
    },
    getMore(mediaType) {
      this.getFeed(mediaType);
    },
    removeSame() {
      var that = this;
      for (let i = 0; i < that.dataUser.length; i++) {
        var key = that.dataUser[i].key;
        let index = _.findIndex(that.data, function (o) {
          return o.key == key;
        });

        if (index > -1) {
          that.data.splice(index, 1);
        }
      }
    },
    getFeed(network) {
      var that = this;
      if (this.more == true) {
        var dat = JSON.stringify({
          feed: network,
          LastEvaluatedKey: that.lek
        });
      } else {
        var dat = JSON.stringify({
          feed: network
        });
      }

      axios
        .post(
          that.url + "getSourceFeeds",
          dat
        )
        .then(function (response) {
          // that.data = response.data.result;
          that.data = _.concat(that.data, response.data.result);
          if (that.more != true) {
            that.getOwnFeed(network);
          } else {
            that.removeSame();
          }
          if (response.data.LastEvaluatedKey) {
            that.lek = response.data.LastEvaluatedKey;
            that.more = true;
          } else {
            that.lek = null;
            that.more = false;
          }
        })
        .catch(function (error) {
          console.log("Error");
          console.log(error);
        });
    },
    getFeedsSearch(mediaType) {
      var that = this;

      axios.post(
          that.url + "getFeedsSearch",
          {
            src: mediaType,
            token: that.providerID
          }
        )
        .then(function(response) {
          that.dataSearch = response.data.data;
        })
        .catch(function(error) {
          console.log("Error");
          console.log(error);
        });
    },
    feedsSearch() {

      var input, filter, ul, li, a, i, txtValue;
      input = event.target;
      filter = this.inSearch.toUpperCase();
      console.log('filter',filter);
      console.log(this.dataSearch);
      this.data = this.dataSearch.filter(function(item) {
        console.log('item.nombre',item.nombre);
        if (item.nombre.toUpperCase().indexOf(filter) > -1) {
          return true;
        } else {
          return false;
        }
      });
      //console.log('data filtrada',this.data);
    },
    getOwnFeed(network) {
      var that = this;
      if (this.more2 == true) {
        var dat = JSON.stringify({
          feed: network,
          token: this.token,
          providerID: this.$store.state.userInfo.net,
          LastEvaluatedKey: that.lek2
        });
      } else {
        var dat = JSON.stringify({
          limit: 20,
          feed: network,
          token: this.token,
          providerID: this.$store.state.userInfo.net
        });
      }
      axios
        .post(
          that.url + "getUserFeeds",
          dat
        )
        .then(function (response) {
          that.dataUser = response.data.result;
          that.removeSame();
          if (response.data.LastEvaluatedKey) {
            that.lek2 = response.data.LastEvaluatedKey;
            that.more2 = true;
            // that.tMedia = type;
          } else {
            that.lek2 = null;
            that.more2 = false;
          }
        })
        .catch(function (error) {
          console.log("Error");
          console.log(error);
        });
    },
    done() {
      /*    let dat = {
            network: this.network,
            array: this.media
        }

        this.$store.commit('updateSNList',dat);
        this.$router.push("/proyecto/nuevo/step2");*/
    },
    changeName() {
      var that = this;

      switch (this.network) {
        case "twitter":
          that.mediaShort = "TW";
          that.getFeedsSearch("TW");
          that.defaultImg = that.$store.state.defaultTwitter
          break;

        case "youtube":
          that.mediaShort = "Y";
          that.getFeedsSearch("Y");
          that.defaultImg = that.$store.state.defaultYoutube
          break;

        case "instagram":
          that.mediaShort = "I";
          that.getFeedsSearch("I");
          that.defaultImg = that.$store.state.defaultInstagram
          break;

        case "facebook":
          that.mediaShort = "FB";
          that.getFeedsSearch("FB");
          that.defaultImg = that.$store.state.defaultFacebook
          break;
        case "tiktok":
          that.mediaShort = "TK";
          that.getFeedsSearch("TK");
          that.defaultImg = that.$store.state.defaultTiktok
          break;

        default:
          that.defaultImg = that.$store.state.defaultNoticiero
          break;
      }
    },
    findID(id) {
      var found = this.mediaJoin.find(function (element) {
        if (element == id) {
          return true;
        } else {
          return false;
        }
      });
      return found;
    }
  },

  beforeMount() {

    this.changeName();
    this.getFeed(this.network);
    //this.getOwnFeed(this.network);

    this.mediaJoin = this.$store.state.projectConfig.fiList[this.mediaShort];
    let param = this.$store.state.projectConfig.fiParams[this.mediaShort];

    /*if ((param[0] == 1 && param[1] == 1) || this.mediaJoin.length == 0) {
      this.selectAll();
      this.selectAllfav();
    }*/
    var combinacion = param[0] + '' + param[1];
    switch (combinacion) {
      case '01':
        this.selectAll();
        break;
      case '10':
        this.selectAllfav();
        break;
      case '11':
        this.selectAll();
        this.selectAllfav();
        break;
      default: break;
    }
  },
  mounted() {
  },
  updated() { }
};
</script>

<style lang="scss">
.avatarMin {
  height: 100%;
  width: 100%;
  border-radius: 50%;
}

.netTitle {
  color: #062633 !important;
}

.user-avatar .data-avatar .user a {
  color: #000;
  margin: 0;
  text-transform: lowercase;
  font-weight: 400;
  font-size: 12px;
  font-family: "Rubik", sans-serif;
}

.selectAll {
  text-align: right;
  margin-right: 30px;
}
</style>
